import ResourceAllocationContext from './context';
import useRaColorAssigner from './hooks/useRaColorAssigner';

const ResourceAllocationProvider = ({ children, period, setPeriod }) => {
  const colorAssigner = useRaColorAssigner();

  return (
    <ResourceAllocationContext.Provider value={{ colorAssigner }}>
      {children}
    </ResourceAllocationContext.Provider>
  );
};

export default ResourceAllocationProvider;
